import { render, staticRenderFns } from "./UpdateVehicle.vue?vue&type=template&id=09ce76b8&"
import script from "./UpdateVehicle.vue?vue&type=script&lang=js&"
export * from "./UpdateVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports